import { Anchor } from "@omni/ui/components/Anchor/anchor.component";

import { useEnergyLabelContext } from "@/components/Product/energyLabel/context/energyLabel.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Fiche = ({ className }: Props) => {
    const { t } = useGranite();

    const energyLabel = useEnergyLabelContext();

    if (!energyLabel.eprel) return null;

    return (
        <Anchor
            href={energyLabel.fiche}
            target={"_blank"}
            color={"link"}
            className={className}
        >
            {t("product.energyLabel.fiche")}
        </Anchor>
    );
};
